import { createContext } from "react";
import { useState } from "react";

export const SessionContext = createContext();

export const SessionProvider = props => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <SessionContext.Provider value={[isLoggedIn, setIsLoggedIn]}>
            {props.children}
        </SessionContext.Provider>
    );

};